var _style, _g, _g2, _g3, _g4, _g5, _g6, _g7, _g8, _g9;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgBio21Lochgrafik14(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 269.3 496",
    style: {
      enableBackground: "new 0 0 269.3 496"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:#D0DE8E;}\n\t.st1{fill:#D03632;}\n\t.st2{fill:#F9DB00;}\n\t.st3{fill:#1F54B0;}\n\t.st4{fill:#FFFFFF;stroke:#000000;stroke-width:0.5;stroke-miterlimit:10;}\n\t.st5{fill:#D1D1D1;}\n\t.st6{fill:#4C702B;}\n\t.st7{fill:none;stroke:#000000;stroke-width:0.56;stroke-dasharray:2.83,2.12,2.83,2.12,2.83,2.12;}\n\t.st8{fill:none;stroke:#000000;stroke-width:0.56;}\n\t.st9{fill:#93B838;}\n\t.st10{fill:#B1CC40;}\n\t.st11{fill:#CAF741;}\n\t.st12{fill:#FEF7CE;}\n\t.st13{fill:#DAEDCF;}\n")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Abschlag"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M160.7,446.7c-6,0.8-4.7,7.9-4,12.2c0.6,4,0.7,10.6,6.9,9.7c5.5-0.8,4.5-5.5,3.8-11 C166.8,452.8,166.6,446,160.7,446.7"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M163.6,431c-3.7,0.9-3,4.7-2.8,6.5c0.2,1.9,1.9,5.2,5.2,4.5s3.2-3.9,2.8-5.9S167.1,430.2,163.6,431"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M144.5,397.3c-3.6,0.3-4.6,3.1-4.2,10c0.4,7.2,1.8,10.6,5.7,9.9s4.2-4.5,3.9-8.8 C149.6,402.7,149.8,396.9,144.5,397.3"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M148.5,401.3c0,2.1-1.7,3.8-3.8,3.8s-3.8-1.7-3.8-3.8c0-2.1,1.7-3.8,3.8-3.8c0,0,0,0,0,0 C146.8,397.5,148.5,399.2,148.5,401.3"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M165,451.5c0,2.1-1.7,3.8-3.8,3.8s-3.8-1.7-3.8-3.8c0-2.1,1.7-3.8,3.8-3.8c0,0,0,0,0,0 C163.3,447.8,165,449.5,165,451.5"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M149.3,413.3c0,2.1-1.7,3.8-3.8,3.8s-3.8-1.7-3.8-3.8c0-2.1,1.7-3.8,3.8-3.8c0,0,0,0,0,0 C147.6,409.5,149.3,411.2,149.3,413.3"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M166.7,464.2c0,2.1-1.7,3.8-3.8,3.8c-2.1,0-3.8-1.7-3.8-3.8c0-2.1,1.7-3.8,3.8-3.8c0,0,0,0,0,0 C165,460.5,166.7,462.2,166.7,464.2"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "Weg"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M174.7,496c-0.5-0.6-50.6-57.5-71.6-82S40,333.4,39.6,332.9l3.1-2.3c0.4,0.6,42.5,56.5,63.4,81 s71,81.4,71.5,82L174.7,496z"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 150.8,
    y: 446.3,
    transform: "matrix(0.9931 -0.1174 0.1174 0.9931 -52.6419 20.9782)",
    className: "st5",
    width: 2.1,
    height: 22.3
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    id: "rough"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M135.6,28.7c-6.6,8-8,14.1-9,25.1c-1.1,11.9-0.7,20.9-6.1,35c-3.5,9.3-3.5,23.6,0,45.7 c4.1,26.3-1,35.3,0.7,53.8c0.7,7.6,4.4,6.8,4.9,12.4c0.4,5.1-3.5,9.2-6.6,14.4c-4.4,7.3-3.7,32.1-3.2,54.5 c0.7,28.7,5.1,39.2,3.7,58.6c-1.7,22.2,3.2,32.1,24.6,29.7c21.6-2.5,14.1-25.5,15.6-73.7c0.6-21.6,6.2-9.6,8.8-31.9 c3.2-27.7-4.1-28.7-2-42.1c2-12.1-1.7-30.7-3.6-41.4c-2.4-13.4,3.5-13.4,3.6-37c0.2-36.5,3.8-55.9,3.9-73.7 c0.1-10.4-0.1-17.5-3.2-26C162.1,16.3,143.5,19,135.6,28.7"
  }))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    id: "uebergang"
  }, /*#__PURE__*/React.createElement("line", {
    className: "st7",
    x1: 127.3,
    y1: 202.6,
    x2: 148.8,
    y2: 177.7
  }), /*#__PURE__*/React.createElement("line", {
    className: "st8",
    x1: 147.6,
    y1: 176.8,
    x2: 149,
    y2: 178.1
  }), /*#__PURE__*/React.createElement("line", {
    className: "st7",
    x1: 123.9,
    y1: 199.3,
    x2: 145.5,
    y2: 174.4
  }), /*#__PURE__*/React.createElement("line", {
    className: "st8",
    x1: 144.9,
    y1: 174.4,
    x2: 146.3,
    y2: 175.6
  }))), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", {
    id: "green_1"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st9",
    d: "M151.4,185.7c-7.5-3.4-15.8,9.5-22.6,22.6c-5.2,10.1-1.7,36.7-1.2,64c0.2,9.9,3,32.6,3.4,47.9 c0.5,17-2.1,28.8,7.1,30.9c15.3,3.5,12.4-12.3,12.8-29.8c0.3-11.2,1.3-35,2.2-45.8c0.2-7.6,2.4-14.9-2-17.5c-2.7-1.6-2.4-4.2-1.3-6 c1.2-2-0.1-1.9-1.1-3.9c-0.6-1.2,0.1-12.9,1-23.7c0.1-0.7,1-4.1,0.4-7.1c-1-4.7-2.1-7.7-1.5-11.1 C149.7,200.3,161.1,190,151.4,185.7"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st9",
    d: "M136.6,70.7c-5.2,5.8-5.7,13.8-3.5,20.2s8.8,12.5,7.4,29.3c-1.4,16.1-15.9,24.7-7.8,38.6 c6.2,10.6,22.9-2.2,24-14.5c0.8-8.4,0.4-15.3-0.1-25.1s2.5-20.4,0.4-25.5c-3.1-7.6-14.4-7.6-12-18.2"
  }))), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", {
    id: "green_2"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st10",
    d: "M142,59.5c0.3,3.3,1.6,3.8-2,7.5s-9.8,9-2.6,13c6,3.3,6.6-0.6,8-6.8c1.2-5.3,7.4-5.1,11.8-10.7 c3.9-5.1,2.6-7.9,1.5-11.2c-1.3-3.7-1.7-4.3,0.6-9.1c1.6-3.3,6.3-9.8,2.9-12.8c-2.6-2.3-5.6-0.8-10.2,2.4c-5.7,3.9-6.4,2.2-9.9,4.7 c-2.3,1.7-2.5,4.1-3.1,7.4c-0.5,2.4-1.3,4.5-0.6,7.6C139.1,55,141.5,55.1,142,59.5"
  }))), _g7 || (_g7 = /*#__PURE__*/React.createElement("g", {
    id: "Put_area"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st11",
    d: "M146.4,63.5c4.5,3.7,11.1-2.8,11.3-7.2c0.2-4-2.7-7.1-2.5-9.8c0.2-3.2,5.8-8,1.5-11.6 c-2.6-2.2-4.8-1.6-6.8-0.1s-4.2,1.1-6.1,2.7c-2.6,2.2-2.2,4.3-2.8,7.7c-0.6,2.8-1.6,5.8,1.6,9.6C144.8,57.4,141.9,59.8,146.4,63.5"
  }))), _g8 || (_g8 = /*#__PURE__*/React.createElement("g", {
    id: "Bunker"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st12",
    d: "M157.2,252.4c0.2,2-0.9,3.8,0.6,6.5s0.1,4.7-1.5,4.6c-2.8,0-1.9-2.2-3.7-4.3c-1.3-1.4-3.5-2.1-3.5-4.1 c-0.1-2.3,0.9-2,1.1-4c0.3-2.3-3-2,0-5.4c1.6-1.8,2-4,4.3-3.5c3.1,0.7,1.8,4.2,1.8,5.5S157.1,250.9,157.2,252.4"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st12",
    d: "M153.9,210.2c-2.5,0-3.8,2.7-3.9,4.6c-0.1,2.3,0.4,3.6,0.4,5.5c-0.1,2.9-2.1,9.3,1.5,10.7 c4.1,1.6,7.1-1.9,4.9-4.8c-1.3-1.7-0.7-3.5,0.9-6.9c0.8-1.4,1.2-3,1.1-4.6C158.5,212.1,156.4,210.2,153.9,210.2"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st12",
    d: "M137.9,125.6c1.1-1.2-0.6-2.6-1.6-3.9c-0.8-1,0.4-2.7-0.9-3.3c-1.6-0.7-1.8,1.4-6.2,1.2 c-0.8,0-2.3-0.8-3.3,0.3c-1.2,1.3,0.7,2.6,1.8,3.6c1.8,1.6,1.3,2.2,2.4,2.6s2.3,0,3.6,0C135.2,126.1,136.5,127.1,137.9,125.6"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st12",
    d: "M125.6,103.4c1.2-1.5,3-1.9,4.6,0.4c1.1,1.4,1.9,1.1,2.9,2.2c1.2,1.3,1.1,4.8,0.5,7.1s-3.7,3.2-4.5,1.8 s-0.4-2.8-1.1-4.1s-1.7-1-2.7-2.7C124.4,106.6,124.5,104.7,125.6,103.4"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st12",
    d: "M159.4,78.6c-0.8,1.6-1.9,2-4.3,2.4s-4,1.9-6.5-0.7c-2.1-2.2-1.8-6.4,0.4-7.2s2.7,2,4.3,2.1 c2.1,0.1,2.4-2.6,5-1.2C160,74.8,160.4,76.6,159.4,78.6"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st12",
    d: "M156.7,67.2c0.1-2.5,1.9-2.8,2.9-3.7c1.9-1.7,1.8-4.1,4.1-3.1c1.7,0.7,1.5,2.6,0.6,4.1 c-1.5,2.5-0.6,3.4-2,4.9C160.7,71.2,156.7,70.2,156.7,67.2"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st12",
    d: "M130.6,54.3c-1.9,1.4-0.2,3.8,1,5c2,2.1,1.7,4.1,3.4,5.3c2.3,1.6,6,0.6,5.6-1.7c-0.4-2.1-2.7-1.2-4.5-2.8 c-2.1-2-1.6-3.3-2.1-4.6C133.1,53.7,132.5,52.9,130.6,54.3"
  }))), _g9 || (_g9 = /*#__PURE__*/React.createElement("g", {
    id: "B\\xE4ume"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st13",
    d: "M190,459.1c-0.4-0.9-1.3-1.4-2.2-1.4c0-0.1-0.1-0.3-0.1-0.4c-0.6-1.3-2.2-1.8-3.5-1.2l-0.3,0.2 c0-0.2-0.1-0.4-0.2-0.6c-0.6-1.3-2.2-1.8-3.4-1.2c0,0,0,0,0,0c-0.2,0.1-0.5,0.3-0.6,0.5c-1.2-0.7-2.8-0.3-3.5,0.9 c-0.2,0.3-0.3,0.7-0.4,1.1c-0.5-0.1-1,0-1.5,0.2c-0.2,0.1-0.5,0.3-0.7,0.5c-0.5,0-0.9,0-1.3,0.2c-1.3,0.6-1.8,2.2-1.2,3.5 c0.1,0.1,0.1,0.3,0.2,0.4c-1.1-1-2.7-0.9-3.7,0.2c-0.7,0.8-0.9,1.9-0.4,2.9c0,0.1,0.1,0.1,0.1,0.2c-0.7,0.5-1.2,1.4-1.1,2.3 c-0.9-0.1-1.8,0.4-2.3,1.1c-0.6-0.3-1.4-0.3-2,0c-0.6-0.9-1.6-1.3-2.7-1.1c-0.5-1.5-0.9-3.1-1.1-4.6c-0.6-1.3-2.2-1.8-3.5-1.2 s-1.8,2.2-1.2,3.5c0.2,0.4,0.5,0.8,0.9,1c0,0.5,0,0.9,0.2,1.3c0.5,1.1,1.7,1.6,2.9,1.4c-0.6,1.3-0.1,2.8,1.2,3.5 c0.7,0.3,1.4,0.4,2.1,0.1c0.8,1.2,2.4,1.5,3.6,0.7c0.3-0.2,0.5-0.4,0.7-0.7c0.7,0.3,1.5,0.3,2.1-0.1l0.2-0.1 c1.2,0.8,2.8,0.4,3.6-0.8c0.2-0.3,0.3-0.6,0.4-0.9c0.7,0.4,1.7,0.4,2.4,0.1c0.6-0.3,1.1-0.7,1.4-1.4c1.4,0.3,2.8-0.7,3-2.1 c0.1-0.6,0-1.1-0.2-1.6c-0.9-0.7-1.3-1.9-0.9-2.9c-0.1-0.2-0.2-0.4-0.4-0.6c0.8-0.4,1.3-1.2,1.4-2.1c0.5,0.1,1,0,1.5-0.2 c0.2-0.1,0.4-0.3,0.6-0.5c0.8,0.4,1.7,0.5,2.5,0.1c0.1-0.1,0.2-0.1,0.3-0.2c0,0.2,0.1,0.4,0.2,0.7c0.4,0.9,1.3,1.4,2.2,1.4 c0,0.1,0.1,0.3,0.1,0.4c0.6,1.3,2.2,1.8,3.5,1.2C190.1,461.9,190.7,460.4,190,459.1L190,459.1"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st13",
    d: "M115.6,401.1c0.5-0.5,0.8-1.3,0.8-2.1c-0.1-0.8-0.5-1.6-1.2-2c0.1-0.4,0.2-0.7,0.2-1.1 c-0.1-1.4-1.4-2.5-2.8-2.3c0,0,0,0,0,0c-0.4,0-0.7,0.2-1.1,0.4c-0.5-0.9-1.5-1.5-2.5-1.5c0.2-0.4,0.3-0.9,0.2-1.3 c-0.1-0.5-0.3-1-0.6-1.4c1.2-0.8,1.5-2.4,0.7-3.6c-0.5-0.8-1.5-1.2-2.4-1.1l-0.3,0v0c-0.1-1.2-1-2.1-2.2-2.3c0-0.1,0-0.3,0-0.4 c-0.1-1.4-1.4-2.5-2.8-2.3c0,0,0,0,0,0c-0.3,0-0.6,0.1-0.8,0.2c0-0.1,0-0.2,0-0.3c-0.1-0.9-0.7-1.7-1.5-2.1 c0.6-0.5,0.8-1.3,0.8-2.1c0-0.5-0.2-0.9-0.5-1.3c0.2-0.4,0.3-0.9,0.2-1.3c-0.1-1.4-1.4-2.5-2.8-2.3c0,0,0,0,0,0h-0.1 c0.1-0.3,0.1-0.6,0.1-0.9c-0.1-1.4-1.4-2.5-2.8-2.4c-0.6,0.1-1.2,0.3-1.6,0.8c-0.2-0.3-0.5-0.6-0.8-0.8c1.2-0.8,1.6-2.4,0.8-3.6 c-0.4-0.6-0.9-1-1.6-1.2c0.3-0.5,0.4-1,0.3-1.6c-0.1-1.4-1.4-2.5-2.8-2.3c0,0,0,0,0,0c-0.2,0-0.3,0-0.4,0.1c0-0.1,0-0.2,0-0.3 c-0.1-1.4-1.4-2.5-2.9-2.3c0,0,0,0,0,0c-0.5,0.1-1,0.2-1.3,0.5c-0.4-1-1.3-1.6-2.4-1.6c0-0.1,0-0.3,0-0.4c-0.1-1.4-1.4-2.5-2.8-2.4 c0,0,0,0,0,0c-0.2,0-0.4,0.1-0.6,0.1c0.1-0.3,0.2-0.7,0.1-1.1c-0.2-1.4-1.6-2.4-3-2.2c-0.9,0.1-1.7,0.8-2,1.6 c-0.9-1.2-2.5-1.4-3.6-0.5c-0.7,0.5-1.1,1.4-1,2.3c0,0.5,0.3,1,0.6,1.4c-1.2,0.8-1.5,2.4-0.7,3.6c0.2,0.2,0.4,0.5,0.6,0.6 c-0.6,1.1-0.3,2.5,0.7,3.3c-1.2,0.8-1.5,2.4-0.7,3.6c0.3,0.4,0.7,0.8,1.2,1l0,0c0.1,1.4,1.4,2.5,2.8,2.3c0,0,0,0,0,0 c0.2,0,0.4-0.1,0.5-0.1c-0.6,1.3-0.1,2.8,1.1,3.5c0.4,0.2,0.9,0.3,1.4,0.3H76c-0.1,0.3-0.1,0.5-0.1,0.8c0.1,0.8,0.6,1.6,1.3,2 c0,0.1,0,0.1,0,0.2c0.1,1.4,1.4,2.5,2.8,2.3c0,0,0,0,0,0l0.3-0.1c-0.1,0.3-0.1,0.5-0.1,0.8c0.1,1.1,0.9,2,2,2.3c0,0.2,0,0.4,0,0.6 c0.1,1.3,1.3,2.4,2.6,2.3c-0.1,0.4-0.2,0.7-0.2,1.1c0.1,1.4,1.4,2.5,2.8,2.3c0,0,0,0,0,0c0.1,0,0.3,0,0.4-0.1 c-0.8,1.2-0.6,2.8,0.6,3.6c0.5,0.4,1.1,0.5,1.8,0.5h0.1c0,0.2,0,0.4,0,0.6c0.1,0.9,0.7,1.7,1.5,2.1c0.2,1.1,1.2,2,2.4,2 c-0.1,0.2-0.1,0.5-0.1,0.8c0.1,1.4,1.4,2.5,2.8,2.3c0.1,0,0.2,0,0.2,0c-0.1,0.4-0.2,0.8-0.2,1.2c0.1,1.2,1.1,2.2,2.3,2.3 c-0.8,1.2-0.5,2.8,0.7,3.6c0.1,0.1,0.2,0.1,0.3,0.2c0,0.2,0,0.3,0,0.5c0.1,1.1,0.9,2,2,2.3c-0.2,0.4-0.2,0.8-0.2,1.2 c0.1,1,0.8,1.9,1.8,2.2c0,0.1,0,0.2,0,0.3c0.2,1.4,1.5,2.4,2.9,2.3c1.3-0.2,2.3-1.3,2.3-2.6c0.4,0.1,0.7,0.2,1.1,0.1 c1.4-0.1,2.5-1.4,2.3-2.8c0,0,0,0,0,0c0-0.2-0.1-0.4-0.1-0.5c1.2-0.3,2.1-1.5,1.9-2.8c0-0.3-0.1-0.6-0.3-0.9 c1.4-0.4,2.2-1.8,1.8-3.1C116.1,401.9,115.9,401.5,115.6,401.1"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st13",
    d: "M178.6,342.4c0.1,1.4-0.9,2.7-2.4,2.8c-1.4,0.1-2.7-0.9-2.8-2.4c-0.1-1.4,0.9-2.7,2.3-2.8 C177.2,340,178.4,341,178.6,342.4C178.6,342.4,178.6,342.4,178.6,342.4"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st13",
    d: "M180.4,334c0.1,1.4-0.9,2.7-2.3,2.8c-1.4,0.1-2.7-0.9-2.8-2.3c-0.1-1.4,0.9-2.7,2.3-2.8 C179,331.5,180.3,332.6,180.4,334C180.4,334,180.4,334,180.4,334"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st13",
    d: "M182.2,327.3c0.1,1.4-0.9,2.7-2.3,2.8c-1.4,0.1-2.7-0.9-2.8-2.3c-0.1-1.4,0.9-2.7,2.3-2.8 C180.8,324.8,182.1,325.9,182.2,327.3C182.2,327.3,182.2,327.3,182.2,327.3"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st13",
    d: "M176.9,323.6c0.1,1.4-0.9,2.7-2.3,2.8c-1.4,0.1-2.7-0.9-2.8-2.3c-0.1-1.4,0.9-2.7,2.3-2.8 C175.5,321.2,176.8,322.2,176.9,323.6C176.9,323.6,176.9,323.6,176.9,323.6"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st13",
    d: "M177.8,318c0.1,1.4-0.9,2.7-2.3,2.8c-1.4,0.1-2.7-0.9-2.8-2.3c-0.1-1.4,0.9-2.7,2.3-2.8 C176.4,315.5,177.7,316.6,177.8,318C177.8,318,177.8,318,177.8,318"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st13",
    d: "M177.8,312.5c0.1,1.4-0.9,2.7-2.3,2.8c-1.4,0.1-2.7-0.9-2.8-2.3c-0.1-1.4,0.9-2.7,2.3-2.8 C176.4,310,177.7,311.1,177.8,312.5C177.8,312.5,177.8,312.5,177.8,312.5"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st13",
    d: "M178.8,306.5c0.1,1.4-0.9,2.7-2.3,2.9s-2.7-0.9-2.9-2.3c-0.1-1.4,0.9-2.7,2.3-2.9c0,0,0,0,0,0 C177.3,304,178.6,305,178.8,306.5"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st13",
    d: "M172.6,299.4c0.1,1.4-0.9,2.7-2.3,2.8c-1.4,0.1-2.7-0.9-2.8-2.3c-0.1-1.4,0.9-2.7,2.3-2.8 C171.1,296.9,172.4,297.9,172.6,299.4C172.5,299.4,172.5,299.4,172.6,299.4"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st13",
    d: "M179.5,290.2c0.1,1.4-0.9,2.7-2.3,2.9s-2.7-0.9-2.9-2.3c-0.1-1.4,0.9-2.7,2.3-2.9c0,0,0,0,0,0 C178.1,287.8,179.3,288.8,179.5,290.2"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st13",
    d: "M179.1,283.3c0.1,1.4-0.9,2.7-2.3,2.8c-1.4,0.1-2.7-0.9-2.8-2.3c-0.1-1.4,0.9-2.7,2.3-2.8 C177.7,280.8,179,281.9,179.1,283.3C179.1,283.3,179.1,283.3,179.1,283.3"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st13",
    d: "M170.9,282.2c0.1,1.4-0.9,2.7-2.3,2.9s-2.7-0.9-2.9-2.3c-0.1-1.4,0.9-2.7,2.3-2.9c0,0,0,0,0,0 C169.5,279.7,170.8,280.8,170.9,282.2C170.9,282.2,170.9,282.2,170.9,282.2"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st13",
    d: "M177.8,269.4c0.1,1.4-0.9,2.7-2.3,2.8c-1.4,0.1-2.7-0.9-2.8-2.3c-0.1-1.4,0.9-2.7,2.3-2.8 C176.4,267,177.7,268,177.8,269.4C177.8,269.4,177.8,269.4,177.8,269.4"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st13",
    d: "M178,264c0.1,1.4-1,2.7-2.5,2.7c-1.3,0.1-2.5-0.9-2.7-2.2c-0.1-1.4,1-2.7,2.5-2.7 C176.6,261.7,177.8,262.7,178,264"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st13",
    d: "M176.7,241.6c-0.5,0.1-0.9,0.2-1.3,0.5c-1.3-0.5-2.8,0.1-3.4,1.4c-0.5,1.3,0.1,2.8,1.4,3.4 c0.4,0.1,0.8,0.2,1.1,0.2c0.5-0.1,0.9-0.2,1.3-0.5c0.4,0.2,0.9,0.3,1.3,0.2c1.4-0.2,2.4-1.5,2.2-3 C179.2,242.6,178,241.6,176.7,241.6"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st13",
    d: "M169.1,247.7c0.1,1.4-0.9,2.7-2.3,2.8c-1.4,0.1-2.7-0.9-2.8-2.3c-0.1-1.4,0.9-2.7,2.3-2.8 C167.7,245.2,168.9,246.3,169.1,247.7C169.1,247.7,169.1,247.7,169.1,247.7"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st13",
    d: "M176.4,230.2c0.1,1.4-0.9,2.7-2.3,2.8c-1.4,0.1-2.7-0.9-2.8-2.3c-0.1-1.4,0.9-2.7,2.3-2.8 C175,227.7,176.2,228.8,176.4,230.2C176.4,230.2,176.4,230.2,176.4,230.2"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st13",
    d: "M174.9,222.5c0.3-0.5,0.4-1,0.4-1.6c-0.1-0.6-0.3-1.2-0.8-1.6c1.2-0.8,1.5-2.4,0.7-3.6 c-0.8-1.2-2.4-1.5-3.6-0.7c-1.2,0.8-1.5,2.4-0.7,3.6c0.1,0.2,0.2,0.3,0.4,0.5c-1.2,0.8-1.5,2.4-0.8,3.6c0.3,0.5,0.8,0.9,1.4,1.1 c-0.7,1.2-0.3,2.8,0.9,3.6c1.2,0.7,2.8,0.3,3.6-0.9c0.7-1.2,0.3-2.8-0.9-3.6C175.3,222.6,175.1,222.5,174.9,222.5"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st13",
    d: "M177.3,193.9c-0.1-1.4-1.4-2.5-2.9-2.3c-0.2,0-0.3,0.1-0.5,0.1c-0.3-1.4-1.6-2.3-3-2s-2.3,1.6-2,3 c0.3,1.3,1.5,2.2,2.8,2.1c0.2,0,0.3-0.1,0.5-0.1c0.1,0.3,0.2,0.6,0.3,0.9c-1.2,0.8-1.5,2.4-0.6,3.6c0.8,1.2,2.4,1.5,3.6,0.6 c0.8-0.5,1.2-1.5,1.1-2.4c0-0.4-0.2-0.8-0.4-1.1C177,195.7,177.4,194.8,177.3,193.9"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st13",
    d: "M175.6,180.7c0.1,1.4-0.9,2.7-2.3,2.8c-1.4,0.1-2.7-0.9-2.8-2.3c-0.1-1.4,0.9-2.7,2.3-2.8 C174.2,178.3,175.5,179.3,175.6,180.7C175.6,180.7,175.6,180.7,175.6,180.7"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st13",
    d: "M179.3,169.2c0.1,1.4-0.9,2.7-2.3,2.8c-1.4,0.1-2.7-0.9-2.8-2.3c-0.1-1.4,0.9-2.7,2.3-2.8 C177.9,166.8,179.2,167.8,179.3,169.2C179.3,169.2,179.3,169.2,179.3,169.2"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st13",
    d: "M174.2,165.4c0.1,1.4-0.9,2.7-2.3,2.8c-1.4,0.1-2.7-0.9-2.8-2.3c-0.1-1.4,0.9-2.7,2.3-2.8 C172.8,162.9,174.1,164,174.2,165.4C174.2,165.4,174.2,165.4,174.2,165.4"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st13",
    d: "M121.2,43.2l5.1-15.5l3-0.3c0.5,1.4,1.9,2.1,3.3,1.6c0.9-0.3,1.5-1.1,1.7-2c1.2-0.3,2-1.5,1.9-2.8 c0,0,0,0,0-0.1l0,0c1.4-0.1,2.5-1.4,2.4-2.8c-0.1-1.1-0.8-2-1.8-2.3l1.4-2.8l9.5-2.1l9.1-0.1l9.9,4.4l-4.9-18.1l-17.6-0.3L126.2,0 l0.5,11.1l-16.5,21.8L121.2,43.2z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st13",
    points: "83.5,117.7 74.1,144.1 87.1,158.9 78.9,177.7 86.4,183 80.6,201.6 66.4,247.9 73.8,256 69.5,264.4  79.2,270.8 72.1,278 78.5,286.5 75.2,294.5 76.3,315.3 92.4,293.6 88.4,285 92,276.8 82.7,252.2 85.3,243.6 89.9,225.3  108.3,221.8 111.4,212 104.8,204.2 106.3,196.7 102.6,191 103.9,180.8 97,172 101,163.8 103.7,154.5 110.5,153.6 106.6,145.8  109.2,138.1 104.4,129.3 107.7,121.7 101.5,112.7  "
  }), /*#__PURE__*/React.createElement("path", {
    className: "st13",
    d: "M157.4,484.3c0,2.5-2,4.5-4.5,4.5c-2.5,0-4.5-2-4.5-4.5c0-2.5,2-4.5,4.5-4.5S157.4,481.8,157.4,484.3 L157.4,484.3"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st13",
    d: "M150.1,463.7c0,2.5-2,4.6-4.5,4.6c-2.5,0-4.6-2-4.6-4.5c0-2.5,2-4.6,4.5-4.6c0,0,0,0,0,0 C148,459.1,150,461.2,150.1,463.7"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st13",
    d: "M141.1,453.5c0,2.5-2,4.5-4.5,4.5c-2.5,0-4.5-2-4.5-4.5c0-2.5,2-4.5,4.5-4.5S141.1,451,141.1,453.5 L141.1,453.5"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st13",
    d: "M134.5,446.4c0,2.5-2,4.5-4.5,4.5c-2.5,0-4.5-2-4.5-4.5c0-2.5,2-4.5,4.5-4.5S134.5,443.8,134.5,446.4 L134.5,446.4"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st13",
    d: "M127.4,438.5c0,2.5-2,4.5-4.5,4.5c-2.5,0-4.5-2-4.5-4.5c0-2.5,2-4.5,4.5-4.5C125.4,434,127.4,436,127.4,438.5 "
  }), /*#__PURE__*/React.createElement("path", {
    className: "st13",
    d: "M121.8,432.5c0,2.5-2,4.6-4.5,4.6c-2.5,0-4.6-2-4.6-4.5c0-2.5,2-4.6,4.5-4.6c0,0,0,0,0,0 C119.7,427.9,121.8,430,121.8,432.5"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st13",
    d: "M166.5,484.3c0,2.5-2,4.5-4.5,4.5c-2.5,0-4.5-2-4.5-4.5c0-2.5,2-4.5,4.5-4.5 C164.4,479.8,166.5,481.8,166.5,484.3"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st13",
    d: "M95.6,419.6c0,2.5-2,4.6-4.5,4.6c-2.5,0-4.6-2-4.6-4.5c0-2.5,2-4.6,4.5-4.6c0,0,0,0,0,0 C93.5,415,95.5,417.1,95.6,419.6"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st13",
    d: "M103.9,423c0,2.5-2,4.5-4.5,4.5c-2.5,0-4.5-2-4.5-4.5c0-2.5,2-4.5,4.5-4.5S103.9,420.5,103.9,423L103.9,423"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st13",
    d: "M104.2,413.9c0,2.5-2,4.6-4.5,4.6c-2.5,0-4.6-2-4.6-4.5c0-2.5,2-4.6,4.5-4.6c0,0,0,0,0,0 C102.2,409.3,104.2,411.4,104.2,413.9"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st13",
    d: "M99.9,416.9c0,2.5-2,4.6-4.5,4.6c-2.5,0-4.6-2-4.6-4.5c0-2.5,2-4.6,4.5-4.6c0,0,0,0,0,0 C97.9,412.3,99.9,414.3,99.9,416.9"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st13",
    d: "M117.4,413.2c0,2.5-2,4.6-4.5,4.6c-2.5,0-4.6-2-4.6-4.5c0-2.5,2-4.6,4.5-4.6c0,0,0,0,0,0 C115.4,408.7,117.4,410.7,117.4,413.2"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st13",
    d: "M129.7,427.1c0,2.5-2,4.5-4.5,4.5c-2.5,0-4.5-2-4.5-4.5c0-2.5,2-4.5,4.5-4.5 C127.6,422.5,129.7,424.6,129.7,427.1"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st13",
    d: "M125.8,423.4c0,2.5-2,4.5-4.5,4.5c-2.5,0-4.5-2-4.5-4.5c0-2.5,2-4.5,4.5-4.5 C123.8,418.9,125.8,420.9,125.8,423.4"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st13",
    d: "M137.1,439.2c0,2.5-2,4.6-4.5,4.6c-2.5,0-4.6-2-4.6-4.5c0-2.5,2-4.6,4.5-4.6c0,0,0,0,0,0 C135,434.7,137.1,436.7,137.1,439.2"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st13",
    d: "M151,451.6c0,2.5-2,4.5-4.6,4.5s-4.6-2-4.6-4.5c0-2.5,2-4.5,4.6-4.5c0,0,0,0,0,0 C149,447.1,151,449.1,151,451.6C151,451.6,151,451.6,151,451.6"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st13",
    d: "M145.9,447.6c0,2.5-2,4.6-4.5,4.6s-4.6-2-4.6-4.5s2-4.6,4.5-4.6c0,0,0,0,0,0 C143.8,443.1,145.9,445.1,145.9,447.6L145.9,447.6"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st13",
    d: "M172.4,476.2c0,2.5-2,4.6-4.5,4.6c-2.5,0-4.6-2-4.6-4.5c0-2.5,2-4.6,4.5-4.6c0,0,0,0,0,0 C170.3,471.6,172.4,473.7,172.4,476.2"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st13",
    d: "M181.4,476.6c0,2.5-2,4.6-4.5,4.6s-4.6-2-4.6-4.5c0-2.5,2-4.6,4.5-4.6c0,0,0,0,0,0 C179.4,472.1,181.4,474.1,181.4,476.6"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st13",
    d: "M190.4,477.6c0,2.5-2,4.5-4.5,4.5c-2.5,0-4.5-2-4.5-4.5c0-2.5,2-4.5,4.5-4.5S190.4,475.1,190.4,477.6 L190.4,477.6"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st13",
    d: "M186.9,469.2c0,2.5-2,4.5-4.5,4.5c-2.5,0-4.5-2-4.5-4.5c0-2.5,2-4.5,4.5-4.5 C184.9,464.6,186.9,466.7,186.9,469.2"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st13",
    d: "M185.1,462.8c0,2.5-2,4.6-4.5,4.6s-4.6-2-4.6-4.5c0-2.5,2-4.6,4.5-4.6c0,0,0,0,0,0 C183.1,458.2,185.1,460.3,185.1,462.8"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st13",
    d: "M177.8,470.6c0,2.5-2,4.6-4.5,4.6s-4.6-2-4.6-4.5c0-2.5,2-4.6,4.5-4.6c0,0,0,0,0,0 C175.8,466.1,177.8,468.1,177.8,470.6"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st13",
    d: "M177.3,484.6c0,2.5-2,4.5-4.5,4.5c-2.5,0-4.5-2-4.5-4.5c0-2.5,2-4.5,4.5-4.5 C175.3,480,177.3,482.1,177.3,484.6"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st13",
    d: "M185.1,483.8c0,2.5-2,4.6-4.5,4.6s-4.6-2-4.6-4.5c0-2.5,2-4.6,4.5-4.6c0,0,0,0,0,0 C183.1,479.2,185.1,481.3,185.1,483.8"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st13",
    d: "M182.7,442.5c0,2.5-2,4.6-4.5,4.6c-2.5,0-4.6-2-4.6-4.5c0-2.5,2-4.6,4.5-4.6c0,0,0,0,0,0 C180.7,438,182.7,440,182.7,442.5"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st13",
    d: "M179.2,426.1c0,2.5-2,4.6-4.5,4.6c-2.5,0-4.6-2-4.6-4.5c0-2.5,2-4.6,4.5-4.6c0,0,0,0,0,0 C177.2,421.5,179.2,423.6,179.2,426.1"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st13",
    d: "M175.8,419.5c0,2.5-2,4.6-4.5,4.6c-2.5,0-4.6-2-4.6-4.5c0-2.5,2-4.6,4.5-4.6c0,0,0,0,0,0 C173.8,415,175.8,417,175.8,419.5"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st13",
    d: "M182,436.1c0,2.5-2,4.6-4.5,4.6c-2.5,0-4.6-2-4.6-4.5c0-2.5,2-4.6,4.5-4.6c0,0,0,0,0,0 C180,431.6,182,433.6,182,436.1"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st13",
    d: "M176.9,400.5c0,2.5-2,4.6-4.5,4.6c-2.5,0-4.6-2-4.6-4.5c0-2.5,2-4.6,4.5-4.6c0,0,0,0,0,0 C174.8,396,176.9,398,176.9,400.5"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st13",
    d: "M171.2,406c0,2.5-2,4.6-4.5,4.6s-4.6-2-4.6-4.5c0-2.5,2-4.6,4.5-4.6c0,0,0,0,0,0 C169.2,401.5,171.2,403.5,171.2,406"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st13",
    d: "M186.8,390c0,2.5-2,4.5-4.5,4.5c-2.5,0-4.5-2-4.5-4.5c0-2.5,2-4.5,4.5-4.5C184.8,385.5,186.8,387.5,186.8,390 "
  }), /*#__PURE__*/React.createElement("path", {
    className: "st13",
    d: "M175.2,390.3c0,2.5-2,4.5-4.5,4.5c-2.5,0-4.5-2-4.5-4.5c0-2.5,2-4.5,4.5-4.5S175.2,387.8,175.2,390.3 L175.2,390.3"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st13",
    d: "M181.7,379.1c0,2.5-2,4.5-4.5,4.5c-2.5,0-4.5-2-4.5-4.5c0-2.5,2-4.5,4.5-4.5 C179.6,374.5,181.7,376.6,181.7,379.1"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st13",
    d: "M188.1,366.5c0,2.5-2,4.5-4.5,4.5c-2.5,0-4.5-2-4.5-4.5c0-2.5,2-4.5,4.5-4.5S188.1,364,188.1,366.5 L188.1,366.5"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st13",
    d: "M83.1,286.5c0,2.5-2,4.5-4.5,4.5c-2.5,0-4.5-2-4.5-4.5c0-2.5,2-4.5,4.5-4.5S83.1,284,83.1,286.5L83.1,286.5"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st13",
    d: "M78,278.3c0,2.5-2,4.5-4.5,4.5c-2.5,0-4.5-2-4.5-4.5c0-2.5,2-4.5,4.5-4.5S78,275.8,78,278.3L78,278.3"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st13",
    d: "M96.2,276.4c0,2.5-2,4.6-4.5,4.6c-2.5,0-4.6-2-4.6-4.5c0-2.5,2-4.6,4.5-4.6c0,0,0,0,0,0 C94.2,271.9,96.2,273.9,96.2,276.4"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st13",
    d: "M87.1,277.9c0,2.5-2,4.6-4.5,4.6s-4.6-2-4.6-4.5c0-2.5,2-4.6,4.5-4.6c0,0,0,0,0,0 C85,273.4,87.1,275.4,87.1,277.9"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st13",
    d: "M83.6,270.6c0,2.5-2,4.5-4.5,4.5c-2.5,0-4.5-2-4.5-4.5c0-2.5,2-4.5,4.5-4.5C81.6,266.1,83.6,268.1,83.6,270.6 "
  }), /*#__PURE__*/React.createElement("path", {
    className: "st13",
    d: "M80.1,314.9c0,2.5-2,4.5-4.5,4.5c-2.5,0-4.5-2-4.5-4.5c0-2.5,2-4.5,4.5-4.5C78.1,310.4,80.1,312.4,80.1,314.9 "
  }), /*#__PURE__*/React.createElement("path", {
    className: "st13",
    d: "M86.9,308.6c0,2.5-2,4.5-4.6,4.5c-2.5,0-4.5-2-4.5-4.6c0-2.5,2-4.5,4.5-4.5C84.9,304,86.9,306,86.9,308.6"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st13",
    d: "M82.9,300.5c0,2.5-2,4.5-4.5,4.5c-2.5,0-4.5-2-4.5-4.5c0-2.5,2-4.5,4.5-4.5c0,0,0,0,0,0 C80.8,296,82.9,298,82.9,300.5C82.9,300.5,82.9,300.5,82.9,300.5"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st13",
    d: "M79.4,294.7c0,2.5-2,4.5-4.5,4.5c-2.5,0-4.5-2-4.5-4.5c0-2.5,2-4.5,4.5-4.5C77.4,290.1,79.4,292.2,79.4,294.7 C79.4,294.7,79.4,294.7,79.4,294.7"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st13",
    d: "M78.1,306c0,2.5-2,4.6-4.5,4.6c-2.5,0-4.6-2-4.6-4.5c0-2.5,2-4.6,4.5-4.6c0,0,0,0,0,0 C76.1,301.5,78.1,303.5,78.1,306"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st13",
    d: "M92.2,301.3c0,2.5-2,4.5-4.5,4.5c-2.5,0-4.5-2-4.5-4.5c0-2.5,2-4.5,4.5-4.5C90.2,296.7,92.2,298.7,92.2,301.3 C92.2,301.3,92.2,301.3,92.2,301.3"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st13",
    d: "M96.9,293.4c0,2.5-2,4.6-4.5,4.6c-2.5,0-4.6-2-4.6-4.5c0-2.5,2-4.6,4.5-4.6c0,0,0,0,0,0 C94.9,288.9,96.9,290.9,96.9,293.4"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st13",
    d: "M88.4,292.9c0,2.5-2,4.6-4.5,4.6c-2.5,0-4.6-2-4.6-4.5c0-2.5,2-4.6,4.5-4.6c0,0,0,0,0,0 C86.3,288.3,88.4,290.4,88.4,292.9"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st13",
    d: "M92.7,285c0,2.5-2,4.6-4.5,4.6c-2.5,0-4.6-2-4.6-4.5c0-2.5,2-4.6,4.5-4.6c0,0,0,0,0,0 C90.7,280.5,92.7,282.5,92.7,285"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st13",
    d: "M92.2,268.6c0,2.5-2.1,4.5-4.6,4.5c-2.5,0-4.5-2.1-4.5-4.6c0-2.5,2.1-4.5,4.5-4.5 C90.2,264,92.2,266,92.2,268.6C92.2,268.5,92.2,268.5,92.2,268.6"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st13",
    d: "M85.6,261.6c0,2.5-2,4.6-4.5,4.6s-4.6-2-4.6-4.5c0-2.5,2-4.6,4.5-4.6c0,0,0,0,0,0 C83.6,257.1,85.6,259.1,85.6,261.6L85.6,261.6"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st13",
    d: "M92.4,260.4c0,2.5-2,4.5-4.5,4.5s-4.5-2-4.5-4.5c0-2.5,2-4.5,4.5-4.5c0,0,0,0,0,0 C90.3,255.8,92.4,257.9,92.4,260.4"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st13",
    d: "M78,255.5c0,2.5-2,4.6-4.5,4.6c-2.5,0-4.6-2-4.6-4.5c0-2.5,2-4.6,4.5-4.6c0,0,0,0,0.1,0 C76,251,78,253,78,255.5"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st13",
    d: "M76.8,264.5c0,2.5-2,4.6-4.5,4.6s-4.6-2-4.6-4.5c0-2.5,2-4.6,4.5-4.6c0,0,0,0,0,0 C74.7,259.9,76.8,262,76.8,264.5L76.8,264.5"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st13",
    d: "M55.4,334c0,2.5-2,4.5-4.5,4.5c-2.5,0-4.5-2-4.5-4.5c0-2.5,2-4.5,4.5-4.5C53.4,329.5,55.4,331.5,55.4,334"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st13",
    d: "M65.8,348.4c0,2.5-2,4.6-4.5,4.6c-2.5,0-4.6-2-4.6-4.5c0-2.5,2-4.6,4.5-4.6c0,0,0,0,0,0 C63.8,343.9,65.8,345.9,65.8,348.4"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st13",
    d: "M62.9,345.1c0,2.5-2,4.6-4.5,4.6s-4.6-2-4.6-4.5c0-2.5,2-4.6,4.5-4.6c0,0,0,0,0,0 C60.8,340.6,62.9,342.6,62.9,345.1"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st13",
    d: "M73.1,359c0,2.5-2,4.6-4.5,4.6c-2.5,0-4.6-2-4.6-4.5c0-2.5,2-4.6,4.5-4.6c0,0,0,0,0,0 C71.1,354.5,73.1,356.5,73.1,359"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st13",
    d: "M78.2,365c0,2.5-2,4.6-4.5,4.6s-4.6-2-4.6-4.5c0-2.5,2-4.6,4.5-4.6c0,0,0,0,0,0 C76.2,360.5,78.2,362.5,78.2,365L78.2,365"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st13",
    d: "M85.1,374.3c0,2.5-2,4.5-4.5,4.5c-2.5,0-4.5-2-4.5-4.5c0-2.5,2-4.5,4.5-4.5S85.1,371.8,85.1,374.3L85.1,374.3 "
  }), /*#__PURE__*/React.createElement("path", {
    className: "st13",
    d: "M93,383.6c0,2.5-2,4.5-4.5,4.5c-2.5,0-4.5-2-4.5-4.5c0-2.5,2-4.5,4.5-4.5C91,379.1,93,381.1,93,383.6 C93,383.6,93,383.6,93,383.6"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st13",
    d: "M99.9,392.8c0,2.5-2,4.6-4.5,4.6c-2.5,0-4.6-2-4.6-4.5c0-2.5,2-4.6,4.5-4.6c0,0,0,0,0,0 C97.9,388.2,99.9,390.3,99.9,392.8"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st13",
    d: "M107.1,401.5c0,2.5-2,4.6-4.5,4.6c-2.5,0-4.6-2-4.6-4.5c0-2.5,2-4.6,4.5-4.6c0,0,0,0,0,0 C105,397,107,399,107.1,401.5"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st13",
    d: "M180.3,299.4c0,2.5-2,4.5-4.5,4.5c-2.5,0-4.5-2-4.5-4.5c0-2.5,2-4.5,4.5-4.5S180.3,296.9,180.3,299.4 L180.3,299.4"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st13",
    d: "M179.6,276.6c0,2.5-2,4.5-4.5,4.5s-4.5-2-4.5-4.5c0-2.5,2-4.5,4.5-4.5C177.6,272.1,179.6,274.1,179.6,276.6 C179.6,276.6,179.6,276.6,179.6,276.6"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st13",
    d: "M179.5,253.3c0,2.5-2,4.5-4.5,4.5s-4.5-2-4.5-4.5s2-4.5,4.5-4.5h0C177.5,248.8,179.5,250.8,179.5,253.3"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st13",
    d: "M72.6,248.2c0,2.5-2,4.5-4.5,4.5c-2.5,0-4.5-2-4.5-4.5c0-2.5,2-4.5,4.5-4.5C70.5,243.7,72.5,245.7,72.6,248.2 "
  }), /*#__PURE__*/React.createElement("path", {
    className: "st13",
    d: "M115.8,212.6c0,2.5-2,4.6-4.5,4.6c-2.5,0-4.6-2-4.6-4.5c0-2.5,2-4.6,4.5-4.6c0,0,0,0,0,0 C113.8,208.1,115.8,210.1,115.8,212.6"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st13",
    d: "M109.4,205.5c0,2.5-2,4.6-4.6,4.6s-4.5-2-4.5-4.6s2-4.6,4.5-4.6S109.4,203,109.4,205.5L109.4,205.5"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st13",
    d: "M106.7,214.6c0,2.5-2,4.6-4.5,4.6s-4.6-2-4.6-4.5c0-2.5,2-4.6,4.5-4.6c0,0,0,0,0,0 C104.6,210.1,106.7,212.1,106.7,214.6"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st13",
    d: "M108.1,229.2c0,2.5-2,4.6-4.5,4.6s-4.6-2-4.6-4.5c0-2.5,2-4.6,4.5-4.6c0,0,0,0,0,0 C106,224.6,108.1,226.7,108.1,229.2"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st13",
    d: "M103.8,223.9c0,2.5-2,4.6-4.5,4.6s-4.6-2-4.6-4.5c0-2.5,2-4.6,4.5-4.6c0,0,0,0,0,0 C101.7,219.4,103.8,221.4,103.8,223.9"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st13",
    d: "M110.6,186.3c0,2.5-2,4.5-4.5,4.5s-4.5-2-4.5-4.5c0-2.5,2-4.5,4.5-4.5c0,0,0,0,0,0 C108.6,181.7,110.6,183.8,110.6,186.3"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st13",
    d: "M106,189.8c0,2.5-2,4.6-4.5,4.6s-4.6-2-4.6-4.5c0-2.5,2-4.6,4.5-4.6c0,0,0,0,0,0 C104,185.3,106,187.3,106,189.8"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st13",
    d: "M103,198.8c0,2.5-2,4.6-4.5,4.6s-4.6-2-4.6-4.5c0-2.5,2-4.6,4.5-4.6c0,0,0,0,0,0 C101,194.2,103,196.2,103,198.8"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st13",
    d: "M100.1,207.7c0,2.5-2,4.5-4.6,4.5c-2.5,0-4.5-2-4.5-4.6s2-4.5,4.6-4.5c0,0,0,0,0,0 C98.1,203.1,100.1,205.2,100.1,207.7C100.1,207.7,100.1,207.7,100.1,207.7"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st13",
    d: "M97.6,216.6c0,2.5-2,4.5-4.5,4.5c-2.5,0-4.5-2-4.5-4.5c0-2.5,2-4.5,4.5-4.5C95.5,212.1,97.5,214.1,97.6,216.6 "
  }), /*#__PURE__*/React.createElement("path", {
    className: "st13",
    d: "M94.6,225.8c0,2.5-2,4.5-4.5,4.5c-2.5,0-4.5-2-4.5-4.5c0-2.5,2-4.5,4.5-4.5C92.6,221.2,94.6,223.3,94.6,225.8 C94.6,225.8,94.6,225.8,94.6,225.8"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st13",
    d: "M91.5,234.9c0,2.5-2,4.5-4.5,4.5c-2.5,0-4.5-2-4.5-4.5c0-2.5,2-4.5,4.5-4.5c0,0,0,0,0,0 C89.5,230.4,91.5,232.4,91.5,234.9"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st13",
    d: "M102.1,173.4c0,2.5-2,4.6-4.5,4.6c-2.5,0-4.6-2-4.6-4.5c0-2.5,2-4.6,4.5-4.6c0,0,0,0,0,0 C100.1,168.8,102.1,170.9,102.1,173.4"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st13",
    d: "M99.7,182.5c0,2.5-2,4.6-4.5,4.6s-4.6-2-4.6-4.5c0-2.5,2-4.6,4.5-4.6c0,0,0,0,0,0 C97.7,178,99.7,180,99.7,182.5"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st13",
    d: "M97,191.6c0,2.5-2,4.6-4.6,4.6s-4.5-2-4.5-4.6s2-4.6,4.5-4.6S97,189.1,97,191.6L97,191.6"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st13",
    d: "M94.1,200.6c0,2.5-2.1,4.5-4.6,4.5S85,203,85,200.5c0-2.5,2-4.5,4.5-4.5C92,196,94.1,198,94.1,200.6"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st13",
    d: "M90.8,209.7c0,2.5-2,4.5-4.5,4.5s-4.5-2-4.5-4.5c0-2.5,2-4.5,4.5-4.5c0,0,0,0,0,0 C88.8,205.2,90.8,207.2,90.8,209.7"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st13",
    d: "M88.2,218.8c0,2.5-2,4.6-4.5,4.6c-2.5,0-4.6-2-4.6-4.5c0-2.5,2-4.6,4.5-4.6c0,0,0,0,0,0 C86.2,214.3,88.2,216.3,88.2,218.8"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st13",
    d: "M85.3,228.1c0,2.5-2,4.6-4.5,4.6c-2.5,0-4.6-2-4.6-4.5c0-2.5,2-4.6,4.5-4.6c0,0,0,0,0,0 C83.3,223.6,85.3,225.6,85.3,228.1"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st13",
    d: "M82.2,237.3c0,2.5-2,4.5-4.5,4.5s-4.5-2-4.5-4.5c0-2.5,2-4.5,4.5-4.5c0,0,0,0,0,0 C80.2,232.7,82.2,234.8,82.2,237.3"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st13",
    d: "M89,243.8c0,2.5-2,4.6-4.5,4.6c-2.5,0-4.6-2-4.6-4.5c0-2.5,2-4.6,4.5-4.6c0,0,0,0,0,0 C87,239.3,89,241.3,89,243.8"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st13",
    d: "M80.2,246.4c0,2.5-2,4.6-4.5,4.6c-2.5,0-4.6-2-4.6-4.5c0-2.5,2-4.6,4.5-4.6c0,0,0,0,0,0 C78.2,241.8,80.2,243.9,80.2,246.4"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st13",
    d: "M104.7,164.6c0,2.5-2,4.5-4.5,4.5s-4.5-2-4.5-4.5c0-2.5,2-4.5,4.5-4.5c0,0,0,0,0,0 C102.6,160.1,104.7,162.1,104.7,164.6"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st13",
    d: "M88.1,167.7c0,2.5-2,4.5-4.5,4.5s-4.5-2-4.5-4.5c0-2.5,2-4.5,4.5-4.5c0,0,0,0,0,0 C86,163.2,88.1,165.2,88.1,167.7"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st13",
    d: "M95.6,166.4c0,2.5-2,4.6-4.5,4.6c-2.5,0-4.6-2-4.6-4.5c0-2.5,2-4.6,4.5-4.6c0,0,0,0,0,0 C93.5,161.9,95.5,163.9,95.6,166.4"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st13",
    d: "M86.2,176.7c0,2.5-2,4.6-4.5,4.6s-4.6-2-4.6-4.5c0-2.5,2-4.6,4.5-4.6c0,0,0,0,0,0 C84.2,172.1,86.2,174.2,86.2,176.7"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st13",
    d: "M108.3,180.5c0,2.5-2,4.5-4.5,4.5s-4.5-2-4.5-4.5c0-2.5,2-4.5,4.5-4.5c0,0,0,0,0,0 C106.3,176,108.3,178,108.3,180.5"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st13",
    d: "M111.1,196.9c0,2.5-2,4.6-4.5,4.6s-4.6-2-4.6-4.5c0-2.5,2-4.6,4.5-4.6c0,0,0,0,0,0 C109,192.4,111.1,194.4,111.1,196.9"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st13",
    d: "M93.2,175.6c0,2.5-2.1,4.5-4.6,4.5s-4.5-2.1-4.5-4.6c0-2.5,2-4.5,4.5-4.5C91.1,171,93.2,173,93.2,175.6"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st13",
    d: "M90.8,184.5c0,2.5-2,4.5-4.5,4.6s-4.5-2-4.6-4.5c0-2.5,2-4.5,4.5-4.6c0,0,0,0,0,0 C88.8,180,90.8,182,90.8,184.5"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st13",
    d: "M88.1,193.6c0,2.5-2,4.5-4.5,4.5s-4.5-2-4.5-4.5c0-2.5,2-4.5,4.5-4.5c0,0,0,0,0,0 C86,189.1,88.1,191.1,88.1,193.6"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st13",
    d: "M85,202.6c0,2.5-2.1,4.5-4.6,4.5s-4.5-2.1-4.5-4.6c0-2.5,2-4.5,4.5-4.5C82.9,198,85,200,85,202.6 C85,202.5,85,202.6,85,202.6"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st13",
    d: "M81.7,211.4c0,2.5-2,4.6-4.6,4.6s-4.5-2-4.5-4.6s2-4.6,4.5-4.6S81.7,208.8,81.7,211.4L81.7,211.4"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st13",
    d: "M78.6,220.3c0,2.5-2,4.5-4.5,4.5c-2.5,0-4.5-2-4.5-4.5c0-2.5,2-4.5,4.5-4.5C76.5,215.8,78.5,217.8,78.6,220.3 "
  }), /*#__PURE__*/React.createElement("path", {
    className: "st13",
    d: "M76,229.8c0,2.5-2,4.6-4.5,4.6c-2.5,0-4.6-2-4.6-4.5c0-2.5,2-4.6,4.5-4.6c0,0,0,0,0,0 C74,225.2,76,227.3,76,229.8"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st13",
    d: "M100.4,238.5c0,2.5-2,4.5-4.5,4.5s-4.5-2-4.5-4.5c0-2.5,2-4.5,4.5-4.5c0,0,0,0,0,0 C98.4,233.9,100.4,236,100.4,238.5"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st13",
    d: "M100.3,232.9c0,2.5-2,4.5-4.5,4.5s-4.5-2-4.5-4.5c0-2.5,2-4.5,4.5-4.5c0,0,0,0,0,0 C98.3,228.3,100.3,230.4,100.3,232.9"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st13",
    d: "M87.2,252.8c0,2.5-2,4.5-4.5,4.5c-2.5,0-4.5-2-4.5-4.6c0-2.5,2-4.5,4.5-4.5C85.1,248.2,87.2,250.3,87.2,252.8 C87.2,252.8,87.2,252.8,87.2,252.8"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st13",
    d: "M74.5,239.2c0,2.5-2,4.6-4.5,4.6c-2.5,0-4.6-2-4.6-4.5c0-2.5,2-4.6,4.5-4.6c0,0,0,0,0,0 C72.4,234.7,74.5,236.7,74.5,239.2"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st13",
    d: "M112.9,221.8c0,2.5-2,4.6-4.5,4.6c-2.5,0-4.6-2-4.6-4.5c0-2.5,2-4.6,4.5-4.6c0,0,0,0,0,0 C110.8,217.2,112.9,219.2,112.9,221.8"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st13",
    d: "M128.9,200.6c0,2.5-2.1,4.5-4.6,4.5s-4.5-2.1-4.5-4.6c0-2.5,2-4.5,4.5-4.5C126.9,196,128.9,198,128.9,200.6"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st13",
    d: "M119.8,195.8c0,2.5-2,4.5-4.5,4.5s-4.5-2-4.5-4.5c0-2.5,2-4.5,4.5-4.5c0,0,0,0,0,0 C117.8,191.3,119.8,193.3,119.8,195.8"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st13",
    d: "M120.7,204.8c0,2.5-2,4.5-4.5,4.5c-2.5,0-4.5-2-4.5-4.5c0-2.5,2-4.5,4.5-4.5 C118.7,200.2,120.7,202.3,120.7,204.8C120.7,204.8,120.7,204.8,120.7,204.8"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st13",
    d: "M169.6,214.2c0,2.5-2,4.5-4.5,4.5s-4.5-2-4.5-4.5c0-2.5,2-4.5,4.5-4.5C167.5,209.6,169.6,211.7,169.6,214.2 C169.6,214.2,169.6,214.2,169.6,214.2"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st13",
    d: "M178.3,208c0,2.5-2,4.6-4.5,4.6c-2.5,0-4.6-2-4.6-4.5c0-2.5,2-4.6,4.5-4.6c0,0,0,0,0,0 C176.3,203.5,178.3,205.5,178.3,208"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st13",
    d: "M169.9,202.9c0,2.5-2,4.6-4.5,4.6s-4.6-2-4.6-4.5s2-4.6,4.5-4.6c0,0,0,0,0,0 C167.9,198.3,169.9,200.4,169.9,202.9"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st13",
    d: "M178.7,160c0,2.5-2,4.6-4.5,4.6s-4.6-2-4.6-4.5s2-4.6,4.5-4.6c0,0,0,0,0,0C176.7,155.5,178.7,157.5,178.7,160 "
  }), /*#__PURE__*/React.createElement("path", {
    className: "st13",
    d: "M105.2,138.9c0,2.5-2,4.6-4.5,4.6s-4.6-2-4.6-4.5c0-2.5,2-4.6,4.5-4.6c0,0,0,0,0,0 C103.2,134.4,105.2,136.4,105.2,138.9"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st13",
    d: "M117,144.8c0,2.5-2,4.5-4.5,4.5s-4.5-2-4.5-4.5c0-2.5,2-4.5,4.5-4.5c0,0,0,0,0,0 C115,140.3,117,142.3,117,144.8"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st13",
    d: "M111.1,146.4c0,2.5-2,4.6-4.5,4.6s-4.6-2-4.6-4.5c0-2.5,2-4.6,4.5-4.6c0,0,0,0,0,0 C109,141.8,111.1,143.9,111.1,146.4"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st13",
    d: "M114.2,137.4c0,2.5-2,4.5-4.5,4.5s-4.5-2-4.5-4.5c0-2.5,2-4.5,4.5-4.5c0,0,0,0,0,0 C112.1,132.9,114.2,134.9,114.2,137.4"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st13",
    d: "M84.2,125.9c0,2.5-2,4.5-4.5,4.5s-4.5-2-4.5-4.5s2-4.5,4.5-4.5C82.2,121.4,84.2,123.4,84.2,125.9"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st13",
    d: "M93.5,124.3c0,2.5-2,4.6-4.5,4.6c-2.5,0-4.6-2-4.6-4.5c0-2.5,2-4.6,4.5-4.6c0,0,0,0,0,0 C91.5,119.8,93.5,121.8,93.5,124.3L93.5,124.3"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st13",
    d: "M99.3,132c0,2.5-2,4.6-4.5,4.6c-2.5,0-4.6-2-4.6-4.5c0-2.5,2-4.6,4.5-4.6c0,0,0,0,0,0 C97.3,127.5,99.3,129.5,99.3,132"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st13",
    d: "M90.2,133.2c0,2.5-2,4.5-4.5,4.5s-4.5-2-4.5-4.5c0-2.5,2-4.5,4.5-4.5c0,0,0,0,0,0 C88.2,128.7,90.2,130.7,90.2,133.2"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st13",
    d: "M81.1,134.7c0,2.5-2,4.6-4.5,4.6s-4.6-2-4.6-4.5c0-2.5,2-4.6,4.5-4.6c0,0,0,0,0,0 C79.1,130.2,81.1,132.2,81.1,134.7"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st13",
    d: "M102.3,148.4c0,2.5-2,4.6-4.5,4.6s-4.6-2-4.6-4.5c0-2.5,2-4.6,4.5-4.6c0,0,0,0,0,0 C100.3,143.8,102.3,145.9,102.3,148.4"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st13",
    d: "M78.4,143.8c0,2.5-2,4.5-4.5,4.5c-2.5,0-4.5-2-4.5-4.5c0-2.5,2-4.5,4.5-4.5C76.4,139.3,78.4,141.3,78.4,143.8 C78.4,143.8,78.4,143.8,78.4,143.8"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st13",
    d: "M96.5,140.9c0,2.5-2,4.5-4.6,4.5c-2.5,0-4.5-2-4.5-4.6s2-4.5,4.6-4.5c0,0,0,0,0,0 C94.4,136.3,96.5,138.4,96.5,140.9C96.5,140.9,96.5,140.9,96.5,140.9"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st13",
    d: "M87.5,142.4c0,2.5-2,4.5-4.6,4.5s-4.5-2-4.5-4.6c0-2.5,2-4.5,4.6-4.5c0,0,0,0,0,0 C85.5,137.8,87.6,139.8,87.5,142.4L87.5,142.4"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st13",
    d: "M84.1,151.1c0,2.5-2,4.6-4.5,4.6s-4.6-2-4.6-4.5c0-2.5,2-4.6,4.5-4.6c0,0,0,0,0,0 C82,146.6,84.1,148.6,84.1,151.1"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st13",
    d: "M93.2,150c0,2.5-2,4.5-4.5,4.5s-4.5-2-4.5-4.5c0-2.5,2-4.5,4.5-4.5c0,0,0,0,0,0 C91.1,145.5,93.2,147.5,93.2,150"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st13",
    d: "M99,157.5c0,2.5-2,4.6-4.5,4.6c-2.5,0-4.6-2-4.6-4.5c0-2.5,2-4.6,4.5-4.6c0,0,0,0,0,0C97,153,99,155,99,157.5 "
  }), /*#__PURE__*/React.createElement("path", {
    className: "st13",
    d: "M90.1,159c0,2.5-2,4.5-4.5,4.5c-2.5,0-4.5-2-4.5-4.5c0-2.5,2-4.5,4.5-4.5C88,154.4,90.1,156.5,90.1,159 C90.1,159,90.1,159,90.1,159"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st13",
    d: "M108,155.9c0,2.5-2,4.6-4.5,4.6s-4.6-2-4.6-4.5c0-2.5,2-4.6,4.5-4.6c0,0,0,0,0,0 C106,151.4,108,153.4,108,155.9"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st13",
    d: "M115.2,154.5c0,2.5-2,4.6-4.6,4.6s-4.5-2-4.5-4.6s2-4.6,4.5-4.6S115.2,152,115.2,154.5L115.2,154.5"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st13",
    d: "M114.1,163.6c0,2.5-2,4.5-4.5,4.5s-4.5-2-4.5-4.5c0-2.5,2-4.5,4.5-4.5c0,0,0,0,0,0 C112.1,159.1,114.1,161.1,114.1,163.6"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st13",
    d: "M105.7,114c0,2.5-2,4.6-4.5,4.6s-4.6-2-4.6-4.5c0-2.5,2-4.6,4.5-4.6c0,0,0,0,0,0 C103.7,109.5,105.7,111.5,105.7,114L105.7,114"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st13",
    d: "M108.5,130.1c0,2.5-2,4.6-4.5,4.6c-2.5,0-4.6-2-4.6-4.5c0-2.5,2-4.6,4.5-4.6c0,0,0,0,0,0 C106.5,125.6,108.5,127.6,108.5,130.1"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st13",
    d: "M87.5,117.2c0,2.5-2,4.6-4.5,4.6c-2.5,0-4.6-2-4.6-4.5c0-2.5,2-4.6,4.5-4.6c0,0,0,0,0,0 C85.5,112.6,87.5,114.7,87.5,117.2"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st13",
    d: "M96.6,115.5c0,2.5-2,4.5-4.5,4.5c-2.5,0-4.5-2-4.5-4.5c0-2.5,2-4.5,4.5-4.5c0,0,0,0,0,0 C94.6,111,96.6,113,96.6,115.5L96.6,115.5"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st13",
    d: "M102.8,123.2c0,2.5-2,4.6-4.5,4.6c-2.5,0-4.6-2-4.6-4.5c0-2.5,2-4.6,4.5-4.6c0,0,0,0,0,0 C100.8,118.6,102.8,120.7,102.8,123.2"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st13",
    d: "M126.1,150.7c0,2.5-2,4.6-4.5,4.6c-2.5,0-4.6-2-4.6-4.5c0-2.5,2-4.6,4.5-4.6c0,0,0,0,0,0 C124.1,146.1,126.1,148.2,126.1,150.7"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st13",
    d: "M119.6,107.4c0,2.5-2,4.6-4.5,4.6c-2.5,0-4.6-2-4.6-4.5c0-2.5,2-4.6,4.5-4.6c0,0,0,0,0,0 C117.6,102.8,119.6,104.9,119.6,107.4"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st13",
    d: "M115,87.9c0,2.5-2,4.5-4.5,4.5s-4.5-2-4.5-4.5c0-2.5,2-4.5,4.5-4.5S115,85.4,115,87.9L115,87.9"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st13",
    d: "M115,83.3c0,2.5-2,4.5-4.5,4.5c-2.5,0-4.5-2-4.5-4.5c0-2.5,2-4.5,4.5-4.5C113,78.8,115,80.8,115,83.3 C115,83.3,115,83.3,115,83.3"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st13",
    d: "M126.8,72c0,2.5-2,4.6-4.5,4.6c-2.5,0-4.6-2-4.6-4.5c0-2.5,2-4.6,4.5-4.6c0,0,0,0,0,0 C124.7,67.5,126.7,69.5,126.8,72"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st13",
    d: "M120.8,67.1c0,2.5-2,4.5-4.5,4.5s-4.5-2-4.5-4.5c0-2.5,2-4.5,4.5-4.5C118.7,62.6,120.8,64.6,120.8,67.1"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st13",
    d: "M124,56.1c0,2.5-2,4.6-4.5,4.6c-2.5,0-4.6-2-4.6-4.5c0-2.5,2-4.6,4.5-4.6c0,0,0,0,0,0 C122,51.6,124,53.6,124,56.1"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st13",
    d: "M113.2,50.7c0,2.5-2,4.6-4.5,4.6s-4.6-2-4.6-4.5s2-4.6,4.5-4.6c0,0,0,0,0,0C111.1,46.1,113.2,48.2,113.2,50.7 L113.2,50.7"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st13",
    d: "M125.8,43.2c0,2.5-2,4.5-4.5,4.5c-2.5,0-4.5-2-4.5-4.5c0-2.5,2-4.5,4.5-4.5C123.7,38.6,125.8,40.7,125.8,43.2 C125.8,43.2,125.8,43.2,125.8,43.2"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st13",
    d: "M170.1,227.3c0,2.5-2,4.5-4.5,4.5s-4.5-2-4.5-4.5s2-4.5,4.5-4.5h0C168.1,222.8,170.1,224.8,170.1,227.3"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st13",
    d: "M114,30.8c0,2.5-2,4.5-4.5,4.5c-2.5,0-4.5-2-4.5-4.5s2-4.5,4.5-4.5C112,26.3,114,28.3,114,30.8"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st13",
    d: "M130.9,27.7c0,2.5-2,4.5-4.5,4.5c-2.5,0-4.5-2-4.5-4.5s2-4.5,4.5-4.5C128.8,23.1,130.9,25.2,130.9,27.7"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st13",
    d: "M122.5,27.7c0,2.5-2,4.6-4.5,4.6c-2.5,0-4.6-2-4.6-4.5s2-4.6,4.5-4.6c0,0,0,0,0,0 C120.4,23.1,122.5,25.2,122.5,27.7"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st13",
    d: "M126,19.5c0,2.5-2,4.5-4.5,4.5s-4.5-2-4.5-4.5s2-4.5,4.5-4.5C124,14.9,126,17,126,19.5L126,19.5"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st13",
    d: "M127.4,35.2c0,2.5-2,4.5-4.5,4.5c-2.5,0-4.5-2-4.5-4.5c0-2.5,2-4.5,4.5-4.5C125.4,30.6,127.4,32.6,127.4,35.2 C127.4,35.2,127.4,35.2,127.4,35.2"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st13",
    d: "M121.2,36.6c0,2.5-2,4.5-4.6,4.5c-2.5,0-4.5-2-4.5-4.6c0-2.5,2-4.5,4.6-4.5c0,0,0,0,0,0 C119.2,32.1,121.2,34.1,121.2,36.6C121.2,36.6,121.2,36.6,121.2,36.6"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st13",
    d: "M106.8,58.1c0,2.5-2,4.5-4.5,4.5c-2.5,0-4.5-2-4.5-4.5c0-2.5,2-4.5,4.5-4.5S106.8,55.6,106.8,58.1L106.8,58.1 "
  }), /*#__PURE__*/React.createElement("path", {
    className: "st13",
    d: "M89.9,65.5c0,2.5-2,4.6-4.5,4.6c-2.5,0-4.6-2-4.6-4.5c0-2.5,2-4.6,4.5-4.6c0,0,0,0,0,0 C87.9,61,89.9,63,89.9,65.5L89.9,65.5"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st13",
    d: "M111.6,121.2c0,2.5-2,4.5-4.6,4.5s-4.5-2-4.5-4.6c0-2.5,2-4.5,4.5-4.5S111.6,118.7,111.6,121.2L111.6,121.2"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st13",
    d: "M172.7,128.4c0,2.5-2,4.6-4.6,4.6s-4.6-2-4.6-4.6c0-2.5,2-4.6,4.6-4.6S172.7,125.9,172.7,128.4L172.7,128.4"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st13",
    d: "M176.3,134.3c0,2.5-2,4.6-4.5,4.6c-2.5,0-4.6-2-4.6-4.5c0-2.5,2-4.6,4.5-4.6c0,0,0,0,0,0 C174.3,129.7,176.3,131.8,176.3,134.3"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st13",
    d: "M172.7,118.2c0,2.5-2,4.5-4.6,4.5s-4.6-2-4.6-4.6c0-2.5,2-4.5,4.6-4.5S172.7,115.7,172.7,118.2L172.7,118.2"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st13",
    d: "M176,122.6c0,2.5-2,4.5-4.5,4.5s-4.5-2-4.5-4.5c0-2.5,2-4.5,4.5-4.5C174,118,176,120.1,176,122.6 C176,122.6,176,122.6,176,122.6"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st13",
    d: "M186.4,85.9c0,2.5-2,4.6-4.5,4.6s-4.6-2-4.6-4.5c0-2.5,2-4.6,4.5-4.6c0,0,0,0,0,0 C184.3,81.3,186.4,83.4,186.4,85.9"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st13",
    d: "M165.4,0c0,2.5-2,4.5-4.5,4.5c-2.5,0-4.5-2-4.6-4.5c0-2.5,2-4.5,4.6-4.5C163.3-4.5,165.4-2.5,165.4,0"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st13",
    d: "M168.4,9c0,2.5-2,4.5-4.5,4.5c-2.5,0-4.5-2-4.5-4.5s2-4.5,4.5-4.5l0,0C166.4,4.5,168.4,6.5,168.4,9"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st13",
    d: "M172.4,27.4c0,2.5-2,4.5-4.6,4.5s-4.6-2-4.6-4.6s2-4.5,4.6-4.5S172.4,24.9,172.4,27.4L172.4,27.4"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st13",
    d: "M170.2,18.4c0,2.5-2,4.6-4.5,4.6c-2.5,0-4.6-2-4.6-4.5s2-4.6,4.5-4.6c0,0,0,0,0,0 C168.1,13.9,170.2,15.9,170.2,18.4"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st13",
    d: "M158.4,6.5c0,2.5-2,4.5-4.5,4.5c-2.5,0-4.5-2-4.5-4.5s2-4.5,4.5-4.5c0,0,0,0,0,0C156.3,1.9,158.4,4,158.4,6.5 "
  }), /*#__PURE__*/React.createElement("path", {
    className: "st13",
    d: "M161.5,15.2c0,2.5-2,4.5-4.5,4.5c-2.5,0-4.5-2-4.5-4.5c0-2.5,2-4.5,4.5-4.5c0,0,0,0,0,0 C159.5,10.6,161.5,12.7,161.5,15.2"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st13",
    d: "M152.1,14.4c0,2.5-2,4.6-4.5,4.6c-2.5,0-4.6-2-4.6-4.5s2-4.6,4.5-4.6c0,0,0,0,0,0 C150.1,9.9,152.1,11.9,152.1,14.4"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st13",
    d: "M143.2,16.6c0,2.5-2,4.5-4.5,4.5c-2.5,0-4.5-2-4.5-4.5s2-4.5,4.5-4.5l0,0C141.1,12.1,143.2,14.1,143.2,16.6"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st13",
    d: "M134.8,20.1c0,2.5-2,4.5-4.5,4.5c-2.5,0-4.5-2-4.5-4.5c0-2.5,2-4.5,4.5-4.5C132.7,15.5,134.8,17.6,134.8,20.1 C134.8,20.1,134.8,20.1,134.8,20.1"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st13",
    d: "M130.8,11.4c0,2.5-2,4.5-4.5,4.5c-2.5,0-4.5-2-4.5-4.5s2-4.5,4.5-4.5C128.8,6.9,130.8,8.9,130.8,11.4 L130.8,11.4"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st13",
    d: "M100.1,50.9c0,2.5-2,4.6-4.5,4.6s-4.6-2-4.6-4.5s2-4.6,4.5-4.6c0,0,0,0,0,0C98.1,46.4,100.1,48.4,100.1,50.9 L100.1,50.9"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st13",
    d: "M97.2,60c0,2.5-2,4.5-4.6,4.5s-4.5-2-4.5-4.6c0-2.5,2-4.5,4.6-4.5c0,0,0,0,0,0C95.2,55.5,97.2,57.5,97.2,60 C97.2,60,97.2,60,97.2,60"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st13",
    d: "M102.7,64.6c0,2.5-2,4.5-4.5,4.5s-4.5-2-4.5-4.5c0-2.5,2-4.5,4.5-4.5S102.7,62.1,102.7,64.6L102.7,64.6"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st13",
    d: "M98,68.9c0,2.5-2,4.5-4.5,4.5s-4.5-2-4.5-4.5c0-2.5,2-4.5,4.5-4.5S98,66.4,98,68.9L98,68.9"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st13",
    d: "M148.9,5.6c0,2.5-2.1,4.5-4.6,4.5c-2.5,0-4.5-2.1-4.5-4.6c0-2.5,2-4.5,4.5-4.5C146.8,1,148.9,3,148.9,5.6 C148.9,5.5,148.9,5.5,148.9,5.6"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st13",
    d: "M139.6,8.2c0,2.5-2,4.5-4.5,4.5c-2.5,0-4.5-2-4.5-4.5c0-2.5,2-4.5,4.5-4.5C137.6,3.7,139.6,5.7,139.6,8.2 C139.6,8.2,139.6,8.2,139.6,8.2"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st13",
    d: "M132.3,1.9c0,2.5-2,4.5-4.5,4.5c-2.5,0-4.5-2-4.5-4.5s2-4.5,4.5-4.5C130.3-2.7,132.3-0.6,132.3,1.9 C132.3,1.9,132.3,1.9,132.3,1.9"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st13",
    d: "M125,290.1c0,2.5-2,4.5-4.5,4.5c-2.5,0-4.5-2-4.5-4.5c0-2.5,2-4.5,4.5-4.5S125,287.6,125,290.1L125,290.1"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st13",
    d: "M127.2,231c0,2.5-2,4.5-4.5,4.5s-4.5-2-4.5-4.5c0-2.5,2-4.5,4.5-4.5c0,0,0,0,0,0 C125.2,226.5,127.2,228.5,127.2,231"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st13",
    d: "M125.8,236.8c0,2.5-2,4.5-4.5,4.5s-4.5-2-4.5-4.5c0-2.5,2-4.5,4.5-4.5c0,0,0,0,0,0 C123.7,232.3,125.8,234.3,125.8,236.8"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st13",
    d: "M129.9,299.2c0,2.5-2,4.5-4.5,4.5c-2.5,0-4.6-2-4.6-4.5c0-2.5,2-4.5,4.5-4.5c0,0,0,0,0,0 C127.9,294.7,129.9,296.7,129.9,299.2C129.9,299.2,129.9,299.2,129.9,299.2"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st13",
    d: "M117,350.6c0,2.5-2,4.5-4.5,4.5c-2.5,0-4.5-2-4.5-4.5c0-2.5,2-4.5,4.5-4.5C115,346.1,117,348.1,117,350.6"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st13",
    d: "M124.6,306.6c0,2.5-2,4.6-4.5,4.6c-2.5,0-4.6-2-4.6-4.5c0-2.5,2-4.6,4.5-4.6c0,0,0,0,0,0 C122.5,302.1,124.6,304.1,124.6,306.6"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBio21Lochgrafik14);
export default __webpack_public_path__ + "static/media/BIO21_lochgrafik_14.ffb14a742ee459fcdc96f748fa5c15ce.svg";
export { ForwardRef as ReactComponent };